import axios from "axios";

class Service {
  url = null;
  startPoint = window.appConfig.apiEndpoint;
  endPoint = null;
  useToken = true;

  constructor() {
    axios.interceptors.request.use((config) => {
      if (this.token) {
        config.headers.Token = `${this.token}`;
      }
      return config;
    });

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error?.response?.status === 403) {
          localStorage.removeItem("token");
          window.location.reload(false);
        }

        return Promise.reject(error);
      }
    );
  }

  get token() {
    return localStorage.getItem("token") ?? null;
  }

  setEndPoint(endPoint) {
    this.endPoint = endPoint;
    this.url = `${this.startPoint}/${this.endPoint}.php`;
  }

  getAll() {
    if (!this.token && this.useToken) {
      console.warn("You are not logged in");
      window.location.reload(false);
      return new Promise((resolve) =>
        resolve({ data: { success: false, data: [] } })
      );
    }

    return this._getAll(axios.get(this.url));
  }

  _getAll(args) {
    return args;
  }

  get(data) {
    if (!this.token && this.useToken) {
      console.warn("You are not logged in");
      window.location.reload(false);
      return new Promise((resolve) =>
        resolve({ data: { success: false, data } })
      );
    }

    const { id } = data;
    return axios.get(`${this.url}?id=${id}`);
  }

  delete(data) {
    if (!this.token && this.useToken) {
      console.warn("You are not logged in");
      window.location.reload(false);
      return new Promise((resolve) =>
        resolve({ data: { success: false, id } })
      );
    }

    const { id } = data;
    return axios.delete(`${this.url}?id=${id}`);
  }

  update(data) {
    if (!this.token && this.useToken) {
      console.warn("You are not logged in");
      window.location.reload(false);
      return new Promise((resolve) =>
        resolve({ data: { success: false, data } })
      );
    }

    return axios.put(`${this.url}`, data);
  }

  create(data, config = {}) {
    if (!this.token && this.useToken) {
      console.warn("You are not logged in");
      window.location.reload(false);
      return new Promise((resolve) =>
        resolve({ data: { success: false, data } })
      );
    }

    return axios.post(`${this.url}`, data, config);
  }
}

export default Service;
